module.exports = __webpack_public_path__ + "img/leader_de.b7ece863.svg";